
export const transform = ({
							  id,
							  name,
							  unit_id,
}) => (
	{
		id: id,
		name: name,
		unit_id: unit_id,
	}
);
